module.exports = __webpack_public_path__ + "fc6020ed62b82552f3d8bb80d86639cf.svg";